import React, { PureComponent } from 'react'
import { Modal, Tooltip, OverlayTrigger, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import InputNumber from '../../commons/form/InputNumber'
import InputDecimal from '../../commons/form/InputDecimal'
import InputCheckBox from '../../commons/form/InputCheckBox'
import InputSelect from '../../commons/form/InputSelect'
import { handleKeyDown } from '../../../util/utils'

class OrganizedUnitConfigurationMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      type: null,
      values: null,
      deleted: false
    }
    this.required = this.required.bind(this)
  }

  submitDocument (values) {
    let value = values.value

    if (this.state.type === 'List<String>' || this.state.type === 'List<Int>') {
      value = values.value.filter(x => x.length > 0).join(',')
    }

    const organizedUnitConfiguration = {
      organizedUnitConfigurationId: values.organizedUnitConfigurationId,
      organizedUnitId: values.organizedUnitId,
      configParameterId: values.configParameterId,
      value: value
    }

    this.props.actions.submitOrganizedUnitConfiguration(organizedUnitConfiguration)
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.props.initialize(this.props.organizedUnitConfiguration)
      this.setState({
        organizedUnitConfiguration: this.props.organizedUnitConfiguration,
        deleted: false,
        values: 1,
        type: this.props.organizedUnitConfiguration?.configParameter?.type
      })
    }
    if (!this.state.deleted && this.props.organizedUnitConfiguration !== null && (this.props.organizedUnitConfiguration?.value)?.length > this.state.values) {
      const count = (this.props.organizedUnitConfiguration?.value)?.length
      this.setState({ values: count })
    }
  }

  changeType (value) {
    this.props.combos.configParameterAllCombo.map(configParameter => {
      if (configParameter.id === value) {
        this.setState({ type: configParameter.code })
        if (this.state.organizedUnitConfiguration !== undefined) {
          let organizedUnitConfiguration = this.state.organizedUnitConfiguration
          organizedUnitConfiguration.value = ''

          if (configParameter.code === 'List<String>' || configParameter.code === 'List<Int>') {
            this.deleteAll()
            this.addElement()
            organizedUnitConfiguration.value = []
          }
          this.setState({
            organizedUnitConfiguration: organizedUnitConfiguration,
            values: 0
          })
        }
      }
    })
  }

  addElement () {
    this.setState({ values: this.state.values + 1 })
  }

  deleteAll (e) {
    if (this.state.organizedUnitConfiguration !== undefined) {
      let organizedUnitConfiguration = this.state.organizedUnitConfiguration
      organizedUnitConfiguration.value = []
      this.setState({
        values: 1,
        deleted: true,
        organizedUnitConfiguration: organizedUnitConfiguration
      })
    } else {
      this.resetForm()
    }
  }

  resetForm () {
    const { reset } = this.props
    reset()
    this.setState({
      values: 1,
      deleted: true,
      type: null
    })
  }

  required (value) {
    if (value || value === 0) {
      return undefined
    } else {
      return this.props.t('MASTERS.ORGANIZED_UNIT_CONFIGURATION_MASTERS.VALIDATION.VALUE_REQUIRED')
    }
  }

  render () {
    const {
      t, handleSubmit,
      showModal,
      combos: { organizedUnitsAllCombo, configParameterAllCombo }
    } = this.props
    const tKey = 'MASTERS.ORGANIZED_UNIT_CONFIGURATION_MASTERS.MODAL.'
    const cancelTooltip = (<Tooltip id="cancelTooltip">{t('ADMIN.USERS.CANCEL_BTN')}</Tooltip>)

    return (
      <Modal id="organizedUnitConfigurationMasterModal" className="_nf" show={showModal} onHide={this.props.actions.closeOrganizedUnitConfigurationMasterModal} backdrop={'static'}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitDocument.bind(this))} onReset={this.handleFormReset} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.closeOrganizedUnitConfigurationMasterModal}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='flexInLineContainer'>
              <div className="flexInL">
                <Field
                  component={InputSelect}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  name="organizedUnitId"
                  controlLabel={t(`${tKey}OU`)}
                  placeholder={t(`${tKey}OU`)}
                  valueKey="id"
                  labelKey="value"
                  options={organizedUnitsAllCombo}
                />
                <Field
                  component={InputSelect}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  name="configParameterId"
                  controlLabel={t(`${tKey}CONFIG_PARAMETER`)}
                  placeholder={t(`${tKey}CONFIG_PARAMETER`)}
                  valueKey="id"
                  labelKey="value"
                  options={configParameterAllCombo}
                  onInputChange={(value) => this.changeType(value)}
                  disabled={this.state.type !== null && this.state.type !== undefined}
                />
              </div>
              <div className="flexInR">
                <OverlayTrigger placement="left" overlay={cancelTooltip}>
                  <a className='_Btn cancel o-icn' onClick={() => this.resetForm()} id="ico-cancel"><i className="iDocIcon-clear-decline"/></a>
                </OverlayTrigger>
              </div>
            </div>
            <div className="search-form">
              {(this.state.type === 'String') && (
                <Field
                  component={InputText}
                  colWidth={100} // 25, 33, 50, 75, 100 default=25
                  name="value"
                  controlLabel={t(`${tKey}VALUE`)}
                  placeholder={t(`${tKey}VALUE`)}
                  validate={[this.required]}
                />
              )}
              {(this.state.type === 'int') && (
                <Field
                  component={InputNumber}
                  colWidth={100} // 25, 33, 50, 75, 100 default=25
                  name="value"
                  controlLabel={t(`${tKey}VALUE`)}
                  placeholder={t(`${tKey}VALUE`)}

                  validate={[this.required]}
                />
              )}
              {(this.state.type === 'Decimal') && (
                <Field
                  component={InputDecimal}
                  colWidth={100} // 25, 33, 50, 75, 100 default=25
                  name="value"
                  controlLabel={t(`${tKey}VALUE`)}
                  placeholder={t(`${tKey}VALUE`)}
                  validate={[this.required]}
                />
              )}
              {(this.state.type === 'Bool') && (
                <Field
                  component={InputCheckBox}
                  colWidth={100} // 25, 33, 50, 75, 100 default=25
                  name="value"
                  controlLabel={t(`${tKey}VALUE`)}
                  placeholder={t(`${tKey}VALUE`)}
                />
              )}
              {(this.state.type === 'List<String>') && new Array(this.state.values).fill(undefined).map((val, idx) => {
                return (
                  <Field
                    component={InputText}
                    colWidth={100} // 25, 33, 50, 75, 100 default=25
                    name={`value[${idx}]`}
                    controlLabel={t(`${tKey}VALUE`)}
                    placeholder={t(`${tKey}VALUE`)}
                  />
                )
              })}
              {(this.state.type === 'List<Int>') && new Array(this.state.values).fill(undefined).map((val, idx) => {
                return (
                  <Field
                    component={InputNumber}
                    colWidth={100} // 25, 33, 50, 75, 100 default=25
                    name={`value[${idx}]`}
                    controlLabel={t(`${tKey}VALUE`)}
                    placeholder={t(`${tKey}VALUE`)}
                  />
                )
              })}
              {(this.state.type === 'List<String>' || this.state.type === 'List<Int>') && (
                <div className="search-form-actions flexInLine al-L">
                  <Button
                    className="_Btn new"
                    onClick={() => this.addElement()}>
                    <i className='iDocIcon-add-plus'></i> {t(`${tKey}ADD`)}
                  </Button>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div sm={12} className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SUBMIT_BUTTON`)}
              </Button>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editOrganizedUnitConfiguration',
  validate: (values, props) => {
    let error = {}
    const tKey = 'MASTERS.ORGANIZED_UNIT_CONFIGURATION_MASTERS.VALIDATION.'
    if (!values.configParameterId) {
      error.configParameterId = props.t(`${tKey}CONFIG_PARAMETER_REQUIRED`)
    }
    return Object.keys(error).length > 0 ? error : {}
  }
})(OrganizedUnitConfigurationMasterModal)
